// extracted by mini-css-extract-plugin
export default {"scoreWrapper":"App_scoreWrapper__7u+I2","controlsWrapper":"App_controlsWrapper__HecRX"};